import { Images } from '@/assets/images';
import {
	AgriFranchiseEnum,
	DocTypeEnum,
	FisheryFranchiseEnum,
	REGEX,
} from '@/constant';
import { cn, dayjs, formatDate, insertObjectIf } from '@/utils';

import { includes } from 'ramda';

import { FormConfig } from '../define-document-write.type';

const initializeValue = {
	employerName: '',
	employerAddress: '',
	employerPhone: '',
	birthDate: '',
	employeeCfmFranchiseName: '',
	employeeCfmEmployerName: '',
	employeeCfmBusinessRegisNo: '',
	employeeCfmFranchisePhone: '',
	applicantName: '',
	applicantBirthDate: '',
	nationality: '',
	reasonForIntroduction: '성실근로',
	district: '',
	// position: '', // '시‧군',
	registerDate: '',
	recommenderSignature: '',
	statusOfStayAndWorkPeriod: 'E-8/8개월',
	recommenderEmployeeName: '',
};

type IValues = typeof initializeValue;

export const RECOMMENDATION_ENTRY_WORKER_CONFIG: FormConfig<
	IValues,
	DocTypeEnum.FRF_04
> = {
	initializeValue,
	title: '계절근로자 재입국 추천서',
	mapPropToValues({ detailData, applicantData, franchiseData, unitData }) {
		return {
			employerName: franchiseData?.employerName || '',
			birthDate: franchiseData?.employerBirthDate || '',
			employerAddress: franchiseData?.address || '',
			employerPhone: franchiseData?.employerPhone || '',
			...insertObjectIf(
				includes(franchiseData?.typeDetail, [
					AgriFranchiseEnum.AGRICULTURAL_CORPORATION_ASSOCIATION,
					AgriFranchiseEnum.PUBLIC_FRANCHISE,
					FisheryFranchiseEnum.FISHING_CORPORATION_ASSOCIATION,
				]),
				{
					employeeCfmFranchiseName: franchiseData?.name,
					employeeCfmEmployerName: franchiseData?.employerName,
					employeeCfmBusinessRegisNo:
						franchiseData?.businessRegistNo ||
						franchiseData?.corporateRegistNo ||
						'',
					employeeCfmFranchisePhone: franchiseData?.phone,
				}
			),
			applicantName: applicantData?.fullName || '',
			applicantBirthDate: applicantData?.foreignerNo || '',
			nationality: applicantData?.nationalName || '',
			district: unitData?.countyDistrict
				? unitData?.countyDistrict
				: detailData?.unitInfo?.countyDistrict || '',
			recommenderEmployeeName: franchiseData?.employerName || '',

			registerDate: formatDate(dayjs()),
		};
	},
	pages: [
		{
			background: {
				src: Images.formAssessmentCertificate,
				className: 'template',
				dataSource: Images.formAssessmentCertificate,
			},

			textAreas: [
				{
					name: 'employerName',
					maxHeight: 40,
					maxLength: 20,
					containerClassName: 'absolute top-[284px] left-[208px] w-[170px]',
					regex: REGEX.ALLOW_KR_EN,
					className: 'text-[16px] leading-none',
				},
				{
					name: 'employerAddress',
					maxHeight: 40,
					maxLength: 200,
					containerClassName: 'absolute top-[327px] left-[207px] w-[250px]',
				},
				{
					name: 'employerPhone',
					maxHeight: 20,
					maxLength: 20,
					containerClassName: 'absolute top-[335px] left-[582px] w-[120px]',
					regex: REGEX.ALLOW_NUMBER,
				},
				{
					name: 'employeeCfmFranchiseName',
					maxHeight: 40,
					maxLength: 20,
					containerClassName: 'absolute top-[431px] left-[204px] w-[148px]',
					regex: REGEX.ALLOW_KR_EN,
					className: 'text-[16px] leading-none',
				},
				{
					name: 'employeeCfmEmployerName',
					maxHeight: 40,
					maxLength: 20,
					containerClassName: 'absolute top-[427px] left-[490px] w-[210px]',
					regex: REGEX.ALLOW_KR_EN,
					className: 'text-[16px] leading-none',
				},
				{
					name: 'employeeCfmBusinessRegisNo',
					maxHeight: 0,
					maxLength: 20,
					containerClassName: 'absolute top-[472px] left-[205px] w-[275px]',
					regex: REGEX.ALLOW_EN_UPPER_CASE_NUMBER_DASH,
				},
				{
					name: 'employeeCfmFranchisePhone',
					maxHeight: 20,
					maxLength: 20,
					containerClassName: 'absolute top-[480px] left-[580px] w-[123px]',
					regex: REGEX.ALLOW_NUMBER,
				},
				{
					name: 'applicantName',
					maxHeight: 51,
					maxLength: 27,
					containerClassName: 'absolute top-[570px] left-[183px] w-[133px]',
					regex: REGEX.ALLOW_KR_EN,
					className: 'text-[16px] leading-none',
				},
				{
					name: 'applicantBirthDate',
					maxHeight: 51,
					maxLength: 20,
					containerClassName: 'absolute top-[570px] left-[550px] w-[155px]',
					regex: REGEX.ALLOW_NUMBER_DASH,
					className: 'text-[16px] leading-none',
				},
				{
					name: 'nationality',
					maxHeight: 51,
					maxLength: 20,
					containerClassName: 'absolute top-[630px] left-[184px] w-[130px]',
					regex: REGEX.ALLOW_KR_EN,
				},
				{
					name: 'statusOfStayAndWorkPeriod',
					maxHeight: 51,
					maxLength: 20,
					containerClassName: 'absolute top-[630px] left-[550px] w-[155px]',
				},
				{
					name: 'reasonForIntroduction',
					maxHeight: 64,
					maxLength: 164,
					containerClassName: 'absolute top-[746px] left-[93px] w-[610px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
					className: 'text-[16px] leading-none',
				},
				(values, index) => ({
					name: 'district',
					maxHeight: 28,
					maxLength: 10,
					className: 'text-[13px] text-center focus:bg-white bg-transparent',
					containerClassName: cn(
						'absolute top-[825px] left-[241px] w-[94px] z-[1]',
						values?.district && 'bg-white'
					),
					regex: REGEX.ALLOW_KR_EN_NUMBER,
					onKeyDown: (e) => {
						if (e.key === 'Tab' || e.key === 'Enter') {
							e.preventDefault();
						}
					},
				}),
				// (values, index) => ({
				// 	name: 'position',
				// 	maxHeight: 24,
				// 	maxLength: 5,
				// 	className: 'text-[16px] text-center',
				// 	containerClassName: cn(
				// 		'absolute top-[825px] left-[293px] w-[43px]',
				// 		values?.district && 'bg-white'
				// 	),
				// 	onKeyDown: (e) => {
				// 		if (e.key === 'Tab' || e.key === 'Enter') {
				// 			e.preventDefault();
				// 		}
				// 	},
				// 	readOnly: true,
				// }),
				{
					name: 'recommenderEmployeeName',
					maxHeight: 60,
					maxLength: 27,
					containerClassName: 'absolute top-[965px] left-[440px] w-[91px]',
					regex: REGEX.ALLOW_KR_EN,
					className: 'text-[16px] leading-none',
				},
			],
			datePickers: [
				{
					name: 'birthDate',
					className: '[&>.ant-picker-input>input]:!text-[12px]',
					containerClassName: 'absolute top-[290px] left-[470px] w-[170px]',
					format: 'YYYY-MM-DD',
					style: {
						fontSize: '12px',
					},
				},
				{
					name: 'registerDate',
					segmentedInputs: true,
					containerClassName: 'absolute top-[921px] left-[272px] w-[200px]',
					format: 'YYYY        MM           DD',
					style: { fontSize: '18px' },
				},
			],
			signatures: [
				{
					name: 'recommenderSignature',
					className: 'absolute bottom-[100px] right-[142px] w-[120px] h-[50px]',
				},
			],
			highlightBoxes: [
				{
					name: 'employerName',
					className: 'top-[290px] left-[115px] !h-[27px] w-[64px]',
				},
				{
					name: 'employerAddress',
					className: 'top-[332px] left-[115px] !h-[27px] w-[65px]',
				},
				{
					name: 'employerPhone',
					className: 'top-[333px] left-[492px] !h-[27px] w-[64px]',
				},
				{
					name: 'birthDate',
					className: 'top-[290px] left-[390px] !h-[27px] w-[64px]',
				},
				{
					name: 'employeeCfmFranchiseName',
					className: 'top-[437px] left-[115px] !h-[24px] w-[64px]',
				},
				{
					name: 'employeeCfmEmployerName',
					className: 'top-[437px] left-[368px] w-[107px]',
				},
				{
					name: 'employeeCfmBusinessRegisNo',
					className: 'top-[480px] left-[96px] w-[99px]',
				},
				{
					name: 'employeeCfmFranchisePhone',
					className: 'top-[480px] left-[500px] w-[64px]',
				},
				{
					name: 'applicantName',
					className: 'top-[573px] left-[106px] !h-[18px] w-[64px]',
				},
				{
					name: 'applicantBirthDate',
					className: 'top-[568px] left-[348px] !h-[16px] w-[166px]',
				},
				{
					name: 'nationality',
					className: 'top-[634px] left-[121px] !h-[16px] w-[30px]',
				},
				{
					name: 'statusOfStayAndWorkPeriod',
					className: 'top-[634px] left-[362px] !h-[16px] w-[141px]',
				},
				{
					name: 'reasonForIntroduction',
					className: 'top-[706px] left-[106px] w-[78px]',
				},
				{
					name: 'district',
					className: 'top-[830px] left-[243px] !h-[17px] w-[50px]',
				},
				{
					name: 'registerDate',
					className: 'bottom-[177px] left-[272px] w-[200px]',
				},
				{
					name: 'recommenderEmployeeName',
					className: 'top-[979px] left-[256px] w-[182px]',
				},
				{
					name: 'recommenderSignature',
					className: 'bottom-[118px] right-[142px] w-[120px] h-[22px]',
				},
			],
		},
	],
};
